import { Paper, type PaperProps } from '../../primitives/Paper'

export type AccordionGroupProps = PaperProps

export const AccordionGroup = (rest: AccordionGroupProps) => <Paper {...rest} />
